import React from 'react';

import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import StartChatInput from 'llm/chat-library/ctas/StartChatInput';

interface AnalyticsDashboardAskInputProps {
  dashboardId: string;
}

export default function AnalyticsDashboardAskInput({
  dashboardId,
}: AnalyticsDashboardAskInputProps): JSX.Element {
  return <StartChatInput itemId={dashboardId} agentType={AgentType.ASK} />;
}
